import { API_URLS } from 'config/constants';
import httpService from './http.service';

export const signIn = async ({ password, email }: { password: string, email: string }) => (
  httpService.post(API_URLS.AUTH.SIGN_IN, { password, email })
);

export const getMe = () => httpService.get(API_URLS.AUTH.ME);
